import React, { useEffect, useState } from "react";
import "./index.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { ID_TAB_EVENT_2024 } from "@config/constants/helper";
import { PATHS } from "@config/constants";
import ChristmasTree from "./ChristmasTree";
import Instruction from "./Instruction";
import NavidadExplosive from "./NavidadExplosive";
import RankTable from "./RankTable";
import Congratulaiton from "./Congratulaiton";
import Header from "./Components/Header";
import bgEvent from "../../../assets/images/event-2024/christmas-theme.png";
import bgEventMobi from "../../../assets/images/event-2024/bg-event-mobi.png";
import bgEventMobiNavi from "../../../assets/images/event-2024/bg-mobi-navi.png";
import PopupComponents from "./Components/PopupComponents";
import { useQuery } from "react-query";
import { getCheckStatusEvent } from "dataLayer/product";

export default function NewYearAndChristmas_2024() {
  const param = useParams();
  const history = useHistory();
  const [openPopupModal, setOpenPopupModal] = React.useState(false);
  const { data: statusEvent } = useQuery(getCheckStatusEvent());
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768); 
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  const handleChangTabs = () => {
    if (statusEvent?.is_finished) {
      switch (param.id) {
        case ID_TAB_EVENT_2024.rankTable:
          return <RankTable />;
        case ID_TAB_EVENT_2024.instruction:
          return <Instruction />;
        case ID_TAB_EVENT_2024.congratulation:
          return <Congratulaiton />;
        default:
          return history.push(PATHS.BID_PAGE);
      }
    } else {
      switch (param.id) {
        case ID_TAB_EVENT_2024.christmasTree:
          return <ChristmasTree />;
        case ID_TAB_EVENT_2024.instruction:
          return <Instruction />;
        case ID_TAB_EVENT_2024.congratulation:
          return <Congratulaiton />;
        case ID_TAB_EVENT_2024.navidadExplosive:
          return <NavidadExplosive />;
        case ID_TAB_EVENT_2024.rankTable:
          return <RankTable />;
        default:
          return history.push(PATHS.BID_PAGE);
      }
    }
  };

  if (!statusEvent?.is_show) {
    return null;
  }

  let setBgEvent = bgEvent;
  if(isMobile){
    if(param.id === ID_TAB_EVENT_2024.navidadExplosive)
      setBgEvent = bgEventMobiNavi
    else 
      setBgEvent = bgEventMobi
  }
  return (
    <div id="event-2024">
      <Header idTab={param.id} statusEvent={statusEvent} />
      <div
        className={`position-relative w-100 h-100 ${
          param.id === ID_TAB_EVENT_2024.instruction
            ? ""
            : param.id === ID_TAB_EVENT_2024.christmasTree
            ? "container-main-event-2024-tab-christmas"
            : ""
        }`}
      >
        <div className={`event-container-bg
          ${
            param.id === ID_TAB_EVENT_2024.navidadExplosive
            ? "event-container-bg-navi"
            : ""
          }
        `}>
          <img src={setBgEvent} alt="bg-event-2024" />
        </div>
        <div className="event-2024-main">{handleChangTabs()}</div>
      </div>

      <PopupComponents open={openPopupModal} setOpen={setOpenPopupModal} />
    </div>
  );
}
